import { format } from 'date-fns';

import { addDays, dayKey, fullDate, localDay } from '@app/utils/helpers/date-utils';

/** Yesterday is stepped by local date parts: subtracting 24 hours is not a day on the mornings the clocks move. */
export const draftingLineFor = (workday: Date, now: Date = new Date()): { key: string; date?: string } => {
  const day = fullDate(workday);

  if (day === dayKey(now)) return { key: 'phillReport.drafting' };
  if (day === dayKey(addDays(now, -1))) return { key: 'phillReport.draftingYesterday' };

  // The same dd/MM/yyyy the Day field above shows, so the two cannot disagree about which day this is.
  return { key: 'phillReport.draftingOn', date: format(localDay(workday), 'dd/MM/yyyy') };
};
